import { DemoData, IOrganization, ISubscription } from '../types';
import { Fetch } from './Fetch';

export interface ISubscriptionEx extends ISubscription {
	organization?: IOrganization;
}

export const Subscription = {
	get: (id: string): Promise<ISubscription> =>
		DemoData.enabled ?
			new Promise<ISubscription>(resolve => resolve(DemoData.getSubscription(id))) :
			Fetch.get(`/management/subscription/${id}`),

	put: (id: string, body: ISubscription) =>
		DemoData.enabled ?
			DemoData.putSubscription(id, body) :
			Fetch.put(`/management/subscription/${id}`, body),

	post: (body: ISubscription) =>
		Fetch.post('/management/subscription', body),

	delete: (id: string, data: ISubscription) =>
		DemoData.enabled ?
		DemoData.deleteSubscription(id, data) :
		Fetch.del(`/management/subscription/${id}`, data),

	//getListUrl: (query?: string) => getUrl('/management/subscription', query),
	auditLogsUrl: (id: string) =>
		Fetch.buildUrl(`/management/subscription/${id}/auditlogs`)
}
